import { t } from "@/i18n-js/instance";
import { Modal } from "@/react/components/shared/uikit/ModalV2";
import { Typography } from "@/react/components/shared/uikit/Typography";

const localeNamespace = "settings.emails.builder.email_builder_selector.modal";

export const ModalHeader = ({ onClose }: { onClose: () => void }) => (
  <Modal.Header className="flex flex-col gap-1">
    <div className="flex w-full justify-between">
      <Modal.Title>{t([localeNamespace, "title"])}</Modal.Title>
      <Modal.HeaderActions>
        <Modal.CloseButton onClick={onClose} />
      </Modal.HeaderActions>
    </div>
    <div className="w-full text-left">
      <Typography.LabelSm color="text-default">
        {t([localeNamespace, "description"])}
      </Typography.LabelSm>
    </div>
  </Modal.Header>
);
